import { BOOLEAN_FLAGS, BooleanFlag } from '../../../../../types/boolean-flag';
import { OptionLabelPair } from '../../../../../components/RadioGroup';

export const AUTOMATICALLY_SYNC_CREDIT_MEMOS_OPTIONS: OptionLabelPair<BooleanFlag>[] = [
  {
    value: BOOLEAN_FLAGS.ENABLED,
    label: 'Automatically sync credit memo upon credit ledger creation',
  },
  { value: BOOLEAN_FLAGS.DISABLED, label: 'Do not sync automatically' },
];
